"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addCookbookToCollectionMutationOptions = exports.addCookbookToCollectionMutation = void 0;
const client_1 = require("@apollo/client");
exports.addCookbookToCollectionMutation = client_1.gql `
  mutation AddCookbookToCollection($cookbookShareId: String!) {
    addCookbookToCollection(cookbookShareId: $cookbookShareId) {
      ok
    }
  }
`;
exports.addCookbookToCollectionMutationOptions = (variables) => ({
    variables,
});
//# sourceMappingURL=addCookbookToCollection.js.map